import Logger from './Logger'

export default class Project {

    project = {}
    activeScene = 0
    activeVersion = 0

    constructor(project) {
        this.project = project

        return this
    }

    get id() {
        return this.project.id
    }

    get name() {
        return this.project.name
    }

    get userName() {
        return this.project.user_name
    }

    get email() {
        return this.project.email
    }

    get hash() {
        return this.project.hash
    }

    get orderId() {
        return this.project.order_id
    }

    get code() {
        return this.project.code
    }

    get scenes() {
        return this.project.scenes
    }

    get scene() {
        return this.scenes[this.activeScene]
    }

    get versions() {
        return this.scene.versions
    }

    get version() {
        return this.versions[this.activeVersion]
    }

    get content() {
        return this.version.content
    }

    get width() {
        return this.version.width
    }
    
    get height() {
        return this.version.height
    }

    /**
     * Get width with frames size
     */
    get totalWidth() {
        let width = parseFloat(this.width)

        width += this.version.margin.left || this.version.margin
        width += this.version.margin.right || this.version.margin

        return width
    }

    get personalizedVersion() {
        return this.versions.find((version) => version.attributes.personalizedField === '1')
    }

    /**
     * Get height with frames size
     */
    get totalHeight() {

        let height = parseFloat(this.height)

        height += this.version.margin.top || this.version.margin
        height += this.version.margin.bottom || this.version.margin

        return height
    }

    /**
     * Set project scene
     */
    setScene(scene) {
        this.activeScene = parseInt(scene)
    }

    /**
     * Set project version
     */
    setVersion(version) {
        this.activeVersion = parseInt(version)
    }

    /**
     * Save project version content
     */
    saveContent(content) {
        console.log('set project content', content)
        // this.version.content = content
    }

    getPersonalizedField() {
        const content = JSON.parse(this.personalizedVersion.content)
        return content.objects.find((object) => object.id === 'personalizedField')
    }

    getPersonalizedCords() {

        const { left, top } = this.getPersonalizedField()

        return {
            x: left,
            y: top
        }
    }

    /**
     * Find fonts used in a project
     * @returns array of fonts name
     */
    getUsedFonts() {
        let fonts = []

        // this.scenes.forEach((scene) => {

            this.versions
                .filter((version) => version.content.length)
                .forEach((version) => {
                    const content = JSON.parse(version.content)

                    if (content.objects) {
                        content.objects
                            .filter((object) => 'fontFamily' in object)
                            .forEach((object) => {
                                fonts.push(object.fontFamily)

                                if ('styles' in object && Object.values(object.styles).length) {
                                    Object.values(object.styles).forEach((line) => {
                                        Object.values(line)
                                            .filter((letter) => 'fontFamily' in letter)
                                            .forEach((letter) => {
                                                fonts.push(letter.fontFamily)
                                            })
                                    })
                                }
                            })
                    }
                })
        // })

        Logger.log('[Project][GetUsedFonts] Found', fonts)
        
        fonts = [...new Set(fonts)]

        Logger.log('[Project][GetUsedFonts] Remove duplicates', fonts)

        return fonts
    }
}